import { ApplicationServiceContainer } from '../container/DIContainer';
import { CreateOrderDto, OrderResponseDto } from '../../application/dtos/OrderDto';

export class OrderService {
  private readonly serviceContainer = ApplicationServiceContainer.getSharedInstance();

  async submitOrder(orderData: CreateOrderDto): Promise<OrderResponseDto> {
    const submitOrderUseCase = this.serviceContainer.resolveSubmitOrderUseCase();
    return await submitOrderUseCase.execute(orderData);
  }

  async getOrder(orderId: string): Promise<OrderResponseDto | null> {
    const getOrderUseCase = this.serviceContainer.resolveGetOrderUseCase();
    return await getOrderUseCase.execute(orderId);
  }

  async getOrdersByStatus(status: string): Promise<OrderResponseDto[]> {
    const orderRepository = this.serviceContainer.resolveOrderRepository();
    const orders = await orderRepository.findByStatus(status);

    return orders.map((order) => {
      const items = order.getItems().map((item) => ({
        variantId: item.getVariantId(),
        productId: item.getProductId().getUniqueIdentifier(),
        sku: item.getSku(),
        productName: item.getProductName(),
        price: item.getPrice().getAmountInDollars(),
        quantity: item.getQuantity(),
        attributes: item.getAttributes(),
        note: item.getNote(),
      }));

      const deliveryInfo = order.getDeliveryInfo();
      const dietaryRequirements = order.getDietaryRequirements();

      return {
        id: order.getId().getUniqueIdentifier(),
        status: order.getStatus(),
        total: order.calculateTotal().getAmountInDollars(),
        itemCount: order.getTotalItemCount(),
        createdAt: order.getCreatedAt().toISOString(),
        items,
        deliveryInfo: {
          fullName: deliveryInfo.fullName,
          phoneNumber: deliveryInfo.phoneNumber.getNormalizedDigits(),
          email: deliveryInfo.email.getEmailAddress(),
          contactMethod: deliveryInfo.contactMethod,
          streetAddress: deliveryInfo.address?.getStreetAddressLine() || null,
          city: deliveryInfo.address?.getCityName() || '',
          state: deliveryInfo.address?.getStateCode() || '',
          zipCode: deliveryInfo.address?.getPostalCode() || '',
          deliveryDate: deliveryInfo.deliveryDate.getTime(),
          deliveryTime: deliveryInfo.deliveryTime,
        },
        dietaryRequirements: {
          vegetarian: dietaryRequirements.vegetarian,
          vegan: dietaryRequirements.vegan,
          glutenFree: dietaryRequirements.glutenFree,
          dairyFree: dietaryRequirements.dairyFree,
          nuts: dietaryRequirements.nuts,
          shellfish: dietaryRequirements.shellfish,
          eggs: dietaryRequirements.eggs,
          soy: dietaryRequirements.soy,
          additionalComments: dietaryRequirements.additionalComments,
        },
        isPaid: order.isPaid(),
        paymentStatus: order.getPaymentStatus(),
      };
    });
  }
}
